import script from "./LayoutMainContent.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutMainContent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__